__turbopack_context__.v({
  "cameraName": "RecordedBroadcastProvider-module__0RSWHG__cameraName",
  "cameraStatus": "RecordedBroadcastProvider-module__0RSWHG__cameraStatus",
  "close": "RecordedBroadcastProvider-module__0RSWHG__close",
  "cursor": "RecordedBroadcastProvider-module__0RSWHG__cursor",
  "error": "RecordedBroadcastProvider-module__0RSWHG__error",
  "heading": "RecordedBroadcastProvider-module__0RSWHG__heading",
  "played": "RecordedBroadcastProvider-module__0RSWHG__played",
  "player": "RecordedBroadcastProvider-module__0RSWHG__player",
  "popup": "RecordedBroadcastProvider-module__0RSWHG__popup",
  "popup-close": "RecordedBroadcastProvider-module__0RSWHG__popup-close",
  "popupClosing": "RecordedBroadcastProvider-module__0RSWHG__popupClosing",
  "statusList": "RecordedBroadcastProvider-module__0RSWHG__statusList",
  "times": "RecordedBroadcastProvider-module__0RSWHG__times",
  "titleRow": "RecordedBroadcastProvider-module__0RSWHG__titleRow",
  "track": "RecordedBroadcastProvider-module__0RSWHG__track",
});
